import * as PIXI from 'pixi.js';
import GSObject from '../../../Game/Base/GSObject';
import Vector from '../../../Game/Base/Math/Vector';

export default class LineVisuals extends GSObject {
    constructor(gsoParent, image) {
        super(gsoParent);

        this.to = new Vector(0, 0);
        this.image = image;
        this.size = 64;
        this.speed = 1;
        this.angleOffset = 0;

        this.pixiLine = null;
    }

    onCreateVisuals() {
        this.pixiLine = new PIXI.extras.TilingSprite(this.image, this.size, this.size);
        this.pixiLine.anchor.set(0.5);

        const mask = new PIXI.Graphics();

        this.pixiLine.addChild(mask);
        this.pixiLine.mask = mask;
        this.pixiLine.tilePosition.x = 0;
        this.pixiLine.alpha = 0.6;
        this.getParentPixiContainer().addChild(this.pixiLine);
    }

    onUpdateVisuals() {
        const angle = Math.atan2(this.to.y, this.to.x) + this.angleOffset;
        const length = this.to.length();

        this.pixiLine.width = length + this.size;

        const { mask } = this.pixiLine;
        mask.clear();
        mask.beginFill(0xffffff);
        mask.drawCircle(-length / 2, 0, this.size / 2);
        mask.drawCircle(length / 2, 0, this.size / 2);
        mask.drawRect(-length / 2, -this.size / 2, length, this.size);

        this.pixiLine.position.x = this.to.x / 2;
        this.pixiLine.position.y = this.to.y / 2;
        this.pixiLine.rotation = angle;
    }

    onDestroyVisuals() {
        this.pixiLine.mask.destroy();
        this.pixiLine.destroy();
    }

    onUpdate(deltaTime) {
        if (this._hasVisuals) {
            this.pixiLine.tilePosition.x += deltaTime * 0.1 * 0.2 * this.speed;
        }
    }
}
